module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "weui-tabbar weui-footer_fixed-bottom bottom"
  }, [_c('router-link', {
    staticClass: "weui-tabbar__item",
    class: _vm.tabbarSelected == 0 ? 'weui-bar__item_on' : '',
    attrs: {
      "to": "/Home"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.tabOnClick(0)
      }
    }
  }, [_c('img', {
    staticClass: "bar-icon home",
    attrs: {
      "src": _vm.tabbarSelected == 0 ? _vm.icons[0][1] : _vm.icons[0][0]
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("首页")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "weui-tabbar__item",
    class: _vm.tabbarSelected == 1 ? 'weui-bar__item_on' : '',
    attrs: {
      "to": "/Form"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.tabOnClick(1)
      }
    }
  }, [_c('img', {
    staticClass: "bar-icon form",
    attrs: {
      "src": _vm.tabbarSelected == 1 ? _vm.icons[1][1] : _vm.icons[1][0]
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("退税单")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "weui-tabbar__item",
    class: _vm.tabbarSelected == 2 ? 'weui-bar__item_on' : '',
    attrs: {
      "to": "/Me"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.tabOnClick(2)
      }
    }
  }, [_c('img', {
    staticClass: "bar-icon me",
    attrs: {
      "src": _vm.tabbarSelected == 2 ? _vm.icons[2][1] : _vm.icons[2][0]
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v("我")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dcc74ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabBar.vue
// module id = 192
// module chunks = 2